export default {
  activeMenuItemClass: 'active-menu-item',
  currentMenuAncestorClass: 'current-menu-ancestor',
  currentMenuItemClass: 'current-menu-item',
  currentMenuParentClass: 'current-menu-parent',
  menuItemElement: 'li',
  menuItemHasChildrenClass: 'menu-item-has-children',
  submenuElement: 'ul',
  submenuClass: 'sub-menu',
};



// WEBPACK FOOTER //
// ./assets/js/cf-dynamic-menu/defaults.js